/* eslint-disable id-length */
import _isNaN from 'lodash/isNaN';
import { add, mid, rot } from './util';
import validateLength from './validation';
import assetsPath from '../util/assetsPath';

const icon = `${assetsPath}/shapes/icons/icon_rectangle.svg`;
const labeledIcon = `${assetsPath}/shapes/labeledIcons/icon_rectangle.svg`;

const rectangle = {
  label: 'Rectangle',
  icon,
  labeledIcon,
  edges: [
    {
      key: 'a',
      shortLabel: 'A',
      longLabel: 'Side A',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'b',
      shortLabel: 'B',
      longLabel: 'Side B',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'c',
      shortLabel: 'C',
      longLabel: 'Side C',
      canEditLength: false,
    },
    {
      key: 'd',
      shortLabel: 'D',
      longLabel: 'Side D',
      canEditLength: false,
    },
  ],
  defaults: {
    edges: {
      a: {
        length: 140, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      b: {
        length: 26, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      c: {
        length: 140, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      d: {
        length: 26, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
    },
    rotation: 0,
  },
  toPolygon: ({ edges: { a, b }, position, rotation }) => {
    const poly = [
      { x: +a.length, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: +b.length },
      { x: +a.length, y: +b.length },
    ];
    return add(rot(poly, (-rotation * Math.PI) / 180, mid(poly)), position);
  },
  validate: ({ edges }) => {
    const errors = {
      a: [],
      b: [],
    };

    // Validate Lengths
    rectangle.edges.forEach((e) => {
      const edge = edges[e.key];
      if (edge) {
        const lengthValidation = validateLength(edge.length, e.minLength, e.maxLength);
        if (lengthValidation) {
          errors[e.key].push(lengthValidation);
        }
        if (edge.hasBacksplash) {
          if (_isNaN(edge.backsplashHeight)) {
            errors[e.key].push('Backsplash Height is not valid');
          } else if (edge.backsplashHeight < 0) {
            errors[e.key].push('Backsplash Height cannot be negative');
          }
        }
      }
    });

    errors.messages = Object.keys(errors).map((edge) => {
      if (errors[edge].length) {
        const edgeMeta = rectangle.edges.find((e) => e.key === edge);
        const message = errors[edge].join('. ');
        return { edge: edgeMeta.longLabel, message: `${message}.` };
      }
      return null;
    }).filter((x) => x);
    errors.isValid = !(errors.messages.length);
    return errors;
  },
};

export default rectangle;
